// The credit-site terms link is rendered as an UpgradeLink but is not an upgrade: let it navigate.
export const isNuxtUpgradeHookLink = (url, config) => Boolean(config.isNuxt) && url !== config.urls.terms
